import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthService {
  loggedIn = false;

  constructor() {}

  requestOptions() {
    let head = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const tokenType = localStorage.getItem('token_type');
    const accessToken = localStorage.getItem('access_token');

    if (tokenType && accessToken) {
      head = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${tokenType} ${accessToken}`
      });
    }

    return {
      headers: head
    };
  }

}
